import Loader from "react-loader-spinner";

export default Loader;
